<div class="company-payment-container">
  <span id="company-payment-method-header" class="company-payment-header">
    {{ "MENU.PAYMENT_METHOD" | translate | uppercase }}
  </span>

  <div class="d-flex pt-2">
    <div class="company-payment-body">
      <div class="company-payment-hint" *ngIf="!isOrganization && !company.defaultPaymentMethodId">
        {{ "COMPANY_PAYMENT_METHOD_HINT" | translate }}
      </div>
      <div class="company-payment-hint" *ngIf="isOrganization && !organization?.defaultPaymentMethod?.id && !isShowSelectedSubscription">
        {{ "COMPANY_PAYMENT_METHOD_HINT" | translate }}
      </div>

      <!--Organization current subscription-->
      <ng-container *ngIf="isShowSelectedSubscription">
        <organization-plan-info-card [subscription]="subscription"></organization-plan-info-card>
      </ng-container>

      <div
        class="company-payment-existing"
        [ngClass]="{ 'company-payment-existing-selected': isDeletePaymentMethod }"
        *ngIf="isOrganization ? organization?.defaultPaymentMethod?.id : !!company.defaultPaymentMethodId && !isAddingPaymentMethod"
      >
        <div class="company-payment-existing-left">
          <div class="company-payment-existing-icon">
            <img [src]="isOrganization ? currentOrganizationPaymentMethodIcon : currentCompanyPaymentMethodIcon" />
          </div>
          <div class="company-payment-existing-text">
            {{ isOrganization ? organization?.defaultPaymentMethodDescription : company.defaultPaymentMethodDescription }}
          </div>
        </div>

        <div class="company-payment-existing-middle">
          {{ "LABELS.DEFAULT" | translate }}
        </div>

        <div class="company-payment-existing-right" *ngIf="!isDeletePaymentMethod">
          <div class="company-payment-existing-action">
            <ng-container *ngTemplateOutlet="dropdown"></ng-container>
          </div>
        </div>
      </div>

      <div class="company-payment-add-container" *ngIf="isAddPaymentMethod">
        <div class="company-payment-add col-lg-8" (click)="setIsAddPaymentMethod(false); setIsSelectPaymentMethod(true)">
          <div class="company-payment-add-left">
            <div class="company-payment-add-icon">
              <img src="/assets/icons/icon_plus.svg" />
            </div>
            <div class="company-payment-add-text">{{ addPaymentMethodText | translate }}</div>
          </div>

          <div class="company-payment-add-right">
            <div class="company-payment-add-arrow">
              <img src="assets/icons/icon_chevron_right.svg" class="company-payment-add-arrow-icon" />
            </div>
          </div>
        </div>

        <div class="company-payment-add-description col-4 ml-3">
          <span [innerHTML]="'ADD_PAYMENT_METHOD_DESCRIPTION' | translate"></span>
        </div>
      </div>

      <ng-container *ngIf="isSelectPaymentMethod">
        <app-payment-methods-card
          [formGroup]="formGroup"
          [paymentMethods]="paymentMethods"
          [isShowFee]="true"
          [isSkipHints]="true"
        ></app-payment-methods-card>

        <div class="d-flex justify-content-between mt-3">
          <button type="button" class="company-payment-btn-cancel" (click)="onPaymentMethodsClose()">
            {{ "BUTTON.CLOSE" | translate }}
          </button>

          <button type="button" class="company-payment-btn-submit" (click)="onAddPayment()">
            <span class="d-flex align-items-center justify-content-center">
              {{ "BUTTON.CONTINUE" | translate }}

              <img class="ml-2" src="assets/icons/icon_arrow_right_white.svg" />
            </span>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="isDeletePaymentMethod">
        <div class="company-payment-delete-header">{{ "DELETE_PAYMENT_METHOD_CONFIRM_TITLE" | translate }}</div>
        <div class="company-payment-delete-hint">{{ "DELETE_PAYMENT_METHOD_CONFIRM" | translate }}</div>

        <div class="company-payment-delete-pending" *ngIf="pendingSum > 0">
          <div class="company-payment-delete-pending-bill">
            <div class="company-payment-delete-pending-bill-label-and-value">
              <div class="company-payment-delete-pending-bill-label">
                {{ "OPEN_MONTHLY_BILL" | translate }}
              </div>
              <div class="company-payment-delete-pending-bill-value">
                {{ pendingSum | currency : DEFAULT_CURRENCY_CODE : "$" : "1.2-2" }}
              </div>
            </div>

            <button type="button" class="company-payment-btn-submit company-payment-btn-submit-sm" (click)="payBill()">
              {{ "PAY_NOW" | translate }}
            </button>
          </div>

          <div class="company-payment-delete-pending-hint">{{ "TO_DELETE_SETTLE_YOUR_OPEN_BILLS" | translate }}</div>
        </div>

        <div class="d-flex justify-content-between flex-column-reverse flex-lg-row mt-3">
          <button type="button" class="company-payment-btn-cancel" (click)="setIsDeletePaymentMethod(false)">
            {{ "BUTTON.CANCEL" | translate }}
          </button>

          <button type="button" class="company-payment-btn-submit" [disabled]="pendingSum > 0" (click)="deletePaymentMethod()">
            <span class="d-flex align-items-center justify-content-center">
              {{ "DELETE_PAYMENT_METHOD_CONFIRM_YES" | translate }}

              <img class="ml-2" src="assets/icons/icon_arrow_right_white.svg" />
            </span>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="isAddingPaymentMethod">
        <ng-container *ngIf="isStripePaymentAvailable">
          <stripe-payment
            [organization]="organization"
            [company]="company"
            [paymentBillType]="enumPaymentBillType.CUSTOM"
            [paymentCodeId]="currentPaymentMethod?.codeId"
            [paymentMethodId]="currentPaymentMethod?.id"
            [referenceNumbers]="[]"
            [returnUrl]="currentUrl"
            [isSetupPage]="true"
            [subscriptionId]="subscription?.id"
            (cancelSetup)="setIsAddingPaymentMethod(false); setIsSelectPaymentMethod(true)"
          ></stripe-payment>
        </ng-container>

        <ng-container *hasFeature="enumUserBetaFlag.paypalFastCheckout">
          <ng-container *ngIf="isPayPalPaymentAvailable">
            <paypal-agreement-redirect [subscriptionId]="subscription?.id" [returnUrl]="currentUrl"></paypal-agreement-redirect>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <loading-spinner [show]="isLoading || isPayPalPaymentTokenLoading"></loading-spinner>
</div>

<ng-template #dropdown>
  <div class="company-payment-menu" dropdown container="body" placement="bottom right">
    <img id="company-payment-menu" class="company-payment-existing-action-icon" src="/assets/icons/icon_pencil_gray.svg" dropdownToggle />

    <ul id="company-payment-dropdown" class="company-payment-menu-list" role="menu" *dropdownMenu>
      <li role="menuitem" class="cursor-pointer" *ngIf="!isSelectPaymentMethod" (click)="updateCurrentPayment()">
        <div class="company-payment-menu-item">
          <div class="company-payment-menu-item-img-container">
            <img src="assets/icons/icon_plus_circle.svg" class="company-payment-menu-item-img company-payment-menu-item-img-add" />
          </div>
          <span>{{ "CHANGE_AND_UPDATE_PAYMENT_METHOD" | translate }}</span>
        </div>
      </li>

      <li
        role="menuitem"
        class="cursor-pointer"
        *ngIf="!(isPendingFailed$ | async)"
        (click)="setIsAddPaymentMethod(false); setIsSelectPaymentMethod(false); setIsDeletePaymentMethod(true)"
      >
        <div class="company-payment-menu-item">
          <div class="company-payment-menu-item-img-container">
            <img src="assets/icons/trash_gray.svg" class="company-payment-menu-item-img company-payment-menu-item-img-delete" />
          </div>
          <span>{{ "DELETE_PAYMENT_METHOD" | translate }}</span>
        </div>
      </li>
    </ul>
  </div>
</ng-template>
